export const REQUEST_PRESS_RELEASES_DATA = 'REQUEST_PRESS_RELEASES_DATA';
export const RECEIVE_PRESS_RELEASES_DATA = 'RECEIVE_PRESS_RELEASES_DATA';

export const receivePressReleasesData = (payload) => ({
  type: RECEIVE_PRESS_RELEASES_DATA,
  payload: payload
});



// WEBPACK FOOTER //
// ./src/actions/pressReleasesActions.js